import { ChordQuality } from '../data/chords';

// Longest-suffix-first: each row is tried with `endsWith`, first match wins.
const SUFFIX_TO_QUALITY: ReadonlyArray<readonly [string, ChordQuality]> = [
  ['7sus4',   'dom7sus4'],
  ['dim7',    'dim7'],
  ['maj7',    'maj7'],
  ['maj9',    'maj9'],
  ['add9',    'add9'],
  ['sus2',    'sus2'],
  ['sus4',    'sus4'],
  ['7#5',     'dom7s5'],
  ['7b9',     'dom7b9'],
  ['7#9',     'dom7s9'],
  ['dim',     'dim'],
  ['m7',      'min7'],
  ['m9',      'min9'],
  ['m6',      'min6'],
  ['ø7',      'min7b5'],
  ['13',      '13'],
  ['7',       'dom7'],
  ['9',       '9'],
  ['6',       '6'],
  ['5',       '5'],
  ['+',       'aug'],
  ['m',       'min'],
];

export function parseChordId(chordId: string): { root: string; quality: ChordQuality } {
  for (const [suffix, quality] of SUFFIX_TO_QUALITY) {
    if (chordId.endsWith(suffix)) {
      const root = chordId.slice(0, chordId.length - suffix.length);
      if (root.length > 0) return { root, quality };
    }
  }
  return { root: chordId, quality: 'maj' };
}
